const artists = state => state.artists
const artist = state => state.artist

export default {
  artists,
  artist
};
